import React from 'react';
import { Card, Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import { shallowEqual, useDispatch } from 'react-redux';
import { addMenu } from '../../redux/slices/menu';
import { useTranslation } from 'react-i18next';
import getSystemIcons from '../../helpers/getSystemIcons';

export default function GiftCard() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const giftcardItems = [
    {
      name: 'products',
      icon: 'dropbox',
      url: 'giftcard/products',
      id: 6,
    }, 
    {
      name: 'GiftCard Categories',
      icon: 'tags',
      url: 'giftcard/giftcard-categories',
      id: 'giftcard-categories',
    },
    {
      name: 'Homepage Products',
      icon: 'home',
      url: 'giftcard/homepage-products',
      id: 'homepage-products',
    },
    {
      name: 'Payment Settings',
      icon: 'dollarCircle',
      url: 'payment-modes',
      id: 'payment-modes',
    }
  ];

  const addMenuItem = (payload) => {
    const data = { ...payload, icon: undefined };
    dispatch(addMenu(data));
  };

  return (
    <div className='product-container'>
      <Row gutter={8}>
        {giftcardItems.map((item) => (
          <Col span={12} key={item.id}>
            <Card className='card-view' hoverable>
              <Link
                to={`/${item.url}`}
                className='d-block'
                onClick={() => addMenuItem(item)}
              >
                {getSystemIcons(item.icon)}
                <span className='text'>{t(item.name)}</span>
              </Link>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
